import React from "react";
import { useTranslation } from "react-i18next";
import { useEditCostProfile } from "@planzone/view-models";
import { CostProfile } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Form } from "./form";
import { CostHistory } from "./costHistory";
import { Props } from "./types";
import styles from "./styles.scss";

function CostProfileEdition({ costProfile, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending: isEditionRequestPending, editCostProfile } =
    useEditCostProfile(costProfile);
  const [formData, setFormData] = React.useState<CostProfile>(costProfile);

  return (
    <Modal header={t("editCostProfile.title")} close={cancel}>
      <form
        className={styles.costProfileEdition}
        onSubmit={(e) => {
          e.preventDefault();

          !isEditionRequestPending &&
            editCostProfile({
              costProfile,
              nextCostProfile: formData,
            });
        }}
      >
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.history}>
          <h3 className={styles.label}>
            {t("editCostProfile.costProfileTitle")}
          </h3>
          <CostHistory costProfile={costProfile} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("editCostProfile.cancel")}
          </Button>
          <Button
            type="submit"
            status={isEditionRequestPending ? "pending" : "none"}
            isDisabled={isEditionRequestPending}
          >
            {t("editCostProfile.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { CostProfileEdition };
